import { toast } from 'sonner';
import type { ApiResponse } from '@driverforce/shared-types';

const FRIENDLY_BY_CODE: Record<string, string> = {
  NETWORK_ERROR: 'Network error — check your connection and try again.',
  UNAUTHORIZED: 'Your session has expired. Please sign in again.',
  FORBIDDEN: "You don't have permission to perform this action.",
  NOT_FOUND: 'The requested resource was not found.',
  UNKNOWN_ERROR: 'Something went wrong. Please try again.',
};

const humanise = (res: { error?: { code?: string; message?: string } }): string => {
  const code = res.error?.code;
  const serverMsg = res.error?.message?.trim();
  if (serverMsg && serverMsg !== 'An unknown error occurred') return serverMsg;
  return (code && FRIENDLY_BY_CODE[code]) ?? FRIENDLY_BY_CODE.UNKNOWN_ERROR;
};

/** Toast a failed ApiResponse and return true; no-op + return false on success. */
export const toastApiError = (
  res: ApiResponse<unknown>,
  fallbackTitle = 'Request failed',
): boolean => {
  if (res.success) return false;
  toast.error(fallbackTitle, { description: humanise(res) });
  return true;
};

/** Toast any thrown/unknown error (network blip, JSON parse, etc.). */
export const toastUnexpected = (err: unknown, fallbackTitle = 'Request failed'): void => {
  const description = err instanceof Error ? err.message : 'An unexpected error occurred.';
  toast.error(fallbackTitle, { description });
};
